var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zj-layout-container',{staticClass:"user-layout"},[_c('div',{staticClass:"zj-layout-left"},[_c('FaceCamera',{ref:"cameratree",attrs:{"OnTreeSelected":_vm.OnTreeSelected}})],1),_c('div',{staticClass:"zj-layout-right"},[_c('FaceList',{ref:"facelist"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }